import moment from 'moment';

export const DaysBetween = (first, second) => {
  const dateOne = moment(first);
  const dateTwo = moment(second);

  return Math.ceil(dateTwo.diff(dateOne, 'days'));
};

export const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const getTimeRange = (date, timeRange) => {
  if (timeRange === 'month') {
    return monthNames[new Date(date * 1000).getUTCMonth()];
  }
  return new Date(date * 1000).getUTCDate();
};

export const addMinutesToTimeStr = (timeStr, minutes) => {
  return moment(timeStr, 'h:ma')
    .add(minutes, 'm')
    .format('h:mmA');
};

export const generateOpenCalendarSlots = lengthOfShowings => {
  // using 14 hours here, starting at 7am going to 9pm, 15 minute increments
  const numberOfSlots = 14 / (15 / 60);

  let slots = [];
  let i;
  for (i = 0; i <= numberOfSlots; i++) {
    slots.push(
      moment('7:00AM', 'h:ma')
        .add(i * 15, 'm')
        .format('h:mmA')
    );
  }

  return slots;
};

export const addDayToCurrentDay = () => {
  return new Date().setDate(new Date().getDate() + 1);
};

export const isSameDay = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  return start.setHours(0, 0, 0, 0) === end.setHours(0, 0, 0, 0);
};
